/** 
* Draw one car detail 
*/

import { logger, beautifyPrice, setHform, dId, showPopUp, dQS, dQSa} from "./utils";
import { reservaD, reservaT, json_vehicle_detail, comsillas, IVA } from "./variables";
import { calcPrice, showPrice, drawPaymentBreakdownBox, drawPresupuestoBox  } from "./result_price";
import { selOfi } from "./result_timetable";
import { variable_km, selKmAlt  } from "./km_alt_functions";
import { langDict } from "./dict";
import { start_tick } from "./loader_ticker";
import { redrawDivs } from "./result_render";
import { addFlightCheckListeners } from "./result_book";

declare const IMAGE_BASE: string;
declare const URL_BASE: any;

function showDetail(json: any) {

  logger("Drawing car detail", "log");
  start_tick();

  // ! Neceesary? jsonDet = json;

  const v = json.vehicle as json_vehicle_detail;
  const o = json.oficina;
  const p = json.pul;
  const d = json.dol;
  const r = json.rates;
  const t = json.dates; // !Dees not exist? 
  const sups = json.sups;
  const young = json.young;

  const termscons = o.tandc;


  let pDiv = "";
  let dDiv = "";
  let dets = v.desc_ESP;  // (not) included in reservation

  let owtx = "";
  let chgow = 0.00;
  let cuota = reservaD[26] * (1 + IVA); // ! Price from previous step
  let clean_price = "";
  let km_dia, km_txt = "";

  let sixtDD = ""; // Km_Alt detail for Sixt / Hertz

  let imgA = "";  // Alternative images
  let imgB = "";  // Alternative images
  let grid = "";  // Grid of icons
  let carPP = ""; // Car description PopuP ...  used in a separate function // ! check
  let fpago = ""; // Forma de pago

  // Update stored values: 
  reservaD[23] = v.grupoexterno + " (" + v.idgrupo + ") / " + v.idgrupoext;
  
  // Km inc and KM Max:
  reservaD[25] = v["kmincluidos"] * reservaD[5];
  reservaD[29] = v["kmmax"];

  // If KM*days > max, set KM inc to KM max.
  // If KM*days < max, set KM max to KM inc.
  if (v["kmmax"] && !isNaN(v["kmmax"])) {
    if ( v["kmmax"] < reservaD[25]) { 
      reservaD[25] = reservaD[29];
    } else {
      reservaD[29] = reservaD[25];
    }

  } 

 
  
  reservaD[40] = o.id;
  reservaD[41] = o.id;
  reservaD[42] = o.personacontacto;
  reservaD[43] = o.correo;
  reservaD[44] = o.telefono;
  reservaD[75] = parseInt(o.pagoprevio);
  reservaD[76] = parseInt(o.pagooficina);
  reservaD[78] = parseFloat(o.pcpagoprev);

  if (typeof young !== "undefined"){
    reservaD[34] = young.precio_dia ?? "0";
    reservaD[35] = young.precio_max ?? "0";
  } else {
    reservaD[34] = "0";
    reservaD[35] = "0";
  }

  if (typeof json.billFull !== "undefined" && json.billFull == 1) {
    reservaD[28] = reservaD[26];
  }

  // Vehicle Image: 
  let imgsrc = IMAGE_BASE + "vehiculos/sinFoto.jpg";

  if (v.iurl.substring(0, 4) == "http") {
    imgsrc = v.iurl;
  } else {
    imgsrc = IMAGE_BASE + "vehiculos/" + v.iurl;
  }

  // Empresa image: 
  let logosrc = IMAGE_BASE + "empresas-mail/" + v.idproveedor + ".png"

  const img = "<span id='zoom_img'><img src='" + imgsrc + "'></span>";

  const officeTip = "<span class='tooltip-office'><img src='" + URL_BASE + "img/info.svg' alt='" + langDict[98] + "' class='icon-sml'><span class='tooltiptext'>" + langDict[108] + "</span></span>";


  // Pick up offices: 
  pDiv = "<label for='pul' >" + langDict[20] + "</label><div class='input-wrap'><select id='pul' name='pul'>";

  for (let i = 0; i < p.length; i++) {

    let showP = false;
    let bajoR = "";

    for (let ra in r) {

      if (typeof r[ra][7] !== "undefined") {
        reservaD[80] = r[0][7]
      }

      if (r[ra][0] == p[i].idoficina && r[ra][4] > 0) {

        if (r[ra][5] == "R") {
          bajoR = " - " + langDict[17]
        }

        showP = true;
        break;

      }
    }

    if (showP || typeof r == "undefined") {
      pDiv += "<option value='" + i + "' >" + p[i]["nombrepunto"] + bajoR + "</option>";
    }
  }
  pDiv += "</select></div>";




  // Dropoff Offices: 
  dDiv = "<label for='dol' >" + langDict[21] + "</label><div class='input-wrap'><select id='dol' name='dol'>";

  for (let i = 0; i < d.length; i++) {

    let showP = false;
    let bajoR = "";

    for (let ra in r) {
      if (r[ra][1] == d[i]["idoficina"] && r[ra][4] > 0) {
        if (r[ra][5] == "R") {
          bajoR = " - " + langDict[17]
        }
        showP = true;
        break
      }
    }

    if (showP || typeof r == "undefined") {
      dDiv += "<option value='" + i + "' >" + d[i]["nombrepunto"] + bajoR + "</option>"
    }

  }
  dDiv += "</select></div>";

  // 2019-04 Hertz / Sixt change: 
  if (v.idproveedor == 25 || v.idproveedor == 18) {

    sixtDD = variable_km(cuota, chgow, r, v.idproveedor);

    if (sixtDD !== "") {
      sixtDD = "<div id='km_alt_detail'>" + sixtDD + "</div>";
    }
  }


  // No Incluido en Reserva: 
  let noi = dets.indexOf("<h4>No");
  if (noi > 0) {
    var dts = "<div>" + dets.substring(0, noi) + "</div><div>" + dets.substring(noi, dets.length) + "</div>";
  } else {
    dts = "<h2>" + langDict[119] + "</h2>" + dets;
  }


  // Extra Images
  if (v["jurl"] !== null && v["jurl"] != "" && v["jurl"] != "0") {
    imgA = "<a id='zoom_img_a'><img src='" + IMAGE_BASE + "vehiculos/" + v["jurl"] + "'></a>"
  }

  if (v["kurl"] !== null && v["kurl"] !== "" && v["kurl"] != "0") {
    imgB = "<a id=zoom_img_b'><img src='" + IMAGE_BASE + "vehiculos/" + v["kurl"] + "'></a>"
  }


  grid = `<div class='veOpts'>
        <img src = '${IMAGE_BASE}icons_af/img_ac_${v.opt_ac}.png'>
        <img src = '${IMAGE_BASE}icons_af/img_pax_${v.opt_pax}.png'>
        <img src = '${IMAGE_BASE}icons_af/img_maletas_${v.opt_maletas}.png'>
        <img src = '${IMAGE_BASE}icons_af/img_puertas_${v.opt_puertas}.png'>
        <img src = '${IMAGE_BASE}icons_af/img_trans_${v.opt_trans}.png'>
        <img src = '${IMAGE_BASE}icons_af/img_fuel_${v.opt_fuel}.png'>
      </div>`;


  carPP = `<h3>${v.modelo}</h3>
        <div class='extraImg'>${img}${imgA}${imgB}</div>
        <div class='extraPrice'>
          ${langDict[97]} ${reservaD[5]} ${langDict[103]} 
          <strong>${km_txt}</strong>
        </div>
        ${grid}
        <div class='descA'>${v.desc_ESP_A}</div> 
        <div class='descB'>${v.desc_ESP_B}</div>`;


  // Forma de Pago Card: 
  fpago = "<img src = 'https://rentoauto.com/images/layout/cards" + o["formapago"] + langDict[92] + ".png'><br>";


  // Human date in language: 
  const fromDate = (<HTMLElement>dId("fecha_salida_pretty")).innerHTML;
  const toDate = (<HTMLElement>dId("fecha_vuelta_pretty")).innerHTML;

  // First div of layout image / description (km extra) / horario
  const html = `
  <section>${img}</section>
  <section>
    <header>${v.modelo}</header>
    <figure class='logo-img'><img src='${logosrc}' alt=''></figure>
    <p>${v.dimensiones}</p>
  </section>
  <section>
    <span class='res-btn btn-sml btn-alt' id="extra_vd">
      <img src="${URL_BASE}img/info.svg" alt="" class="icon-sml-invert">
      ${langDict[98]}
    </span>
  </section>

  <section>
    <header>
      <img src="${URL_BASE}img/date.svg" class="icon-sml-accent" alt="">
      ${langDict[83]}
    </header>
    <div>
      <div>
        <header>${langDict[104]} ${officeTip}</header>
        ${fromDate}<br>${reservaD[2]} 
      </div>
      <div>
        <header>${langDict[105]}</header>
        ${toDate}<br>${reservaD[4]}
      </div>
    </div>
  </section>


  <section>
    <header>
      <img src="${URL_BASE}/img/location.svg" class="icon-sml-accent" alt="">
      ${langDict[85]}
    </header>
    <div>
    <div>
        <header>${langDict[104]}</header>
        <div>${pDiv}</div>
      </div>
      <div>
        <header>${langDict[105]}</header>
        <div>${dDiv}</div>
      </div>
    </div>
  </section>

  <section id='descripcion_horario'></section>

  <section>${sixtDD}</section>
  <section>${fpago}</section>
  <section class='price'><span class='fPrice'>0,00</span></section>
  <section id='resActivator'></section>`;

  (<HTMLElement>dId("resDetail")).innerHTML = html;
  (<HTMLElement>dId("resIncluye")).innerHTML = dts;

  showPrice(); 
  drawPresupuestoBox();
  drawPaymentBreakdownBox("yes");


  let scroll_loc = (<HTMLElement>dId("resDetail")).offsetTop - document.body.scrollTop - 100;
  document.body.scrollTop = scroll_loc;


  selOfi("pul",r,p,d, sups, young);
  selOfi("dol",r,p,d, sups, young);

  toggleReservaButtons( sups, young );

  // Terms and conditions store HTML: 
  (<HTMLElement>dId("TC_description")).innerHTML = termscons;

  // Listeners:   // !Remember to clear when repeating show detail: 

  (<HTMLElement>dId("extra_vd")).addEventListener("click", ()=>{showExtraVD(carPP); } );
  (<HTMLSelectElement>dId("pul")).addEventListener("change", ()=>{ selOfi("pul", r, p, d, sups, young); } );
  (<HTMLSelectElement>dId("dol")).addEventListener("change", ()=>{ selOfi("dol", r, p, d, sups, young); } );

  // Add event listeners: 
  if (sixtDD !== "") {
    (<HTMLSelectElement>dId("km_alt")).addEventListener("change", ()=>{ selKmAlt(r); } );
  }


  (<HTMLElement>dId("zoom_img")).addEventListener("click", () => { zoomImg(imgsrc); });

  if (imgA !== "") {
    if (dId("zoom_img_a")){
      (<HTMLElement>dId("zoom_img_a")).addEventListener("click", () => { zoomImg(IMAGE_BASE + "vehiculos/" + v["jurl"]); });
    }
  }

  if (imgB !== "") {
    if (dId("zoom_img_b")){
      (<HTMLElement>dId("zoom_img_b")).addEventListener("click", () => { zoomImg(IMAGE_BASE + "vehiculos/" + v["kurl"]); });
    }
  }

  setHform();


  addFlightCheckListeners();

 
}


// Show / Hide reserva buttons depending on payment options for vehicle.
function toggleReservaButtons(sups: any[], young: {}) {

  logger("Toggle Reservation Block", "log");

  const res_confirm = (<HTMLElement>dId("resFormDiv"));
  const res_button = (<HTMLElement>dId("resActivator"));
  const res_prepay = (<HTMLElement>dId("res_prepay"));
  const res_bizum = (<HTMLElement>dId("res_bizum"));
  const res_oficina = (<HTMLElement>dId("res_oficina"));

	if (reservaD[51] == "OK" 
    && reservaD[52] == "OK" 
    && reservaD[26] > 0 
    && reservaD[5] > 0) {

		res_button.innerHTML = "<span class='res-btn btn-large' id='res_step_3_btn'>" + langDict[38] + "</span>";
		
		// 2021-04 Show Bank Pay and Bizum Pay: 
		if (reservaD[75]==1) { 
			res_prepay.style.display = "inline-flex"; 
			res_bizum.style.display = "inline-flex"; 
		} else { 
			res_prepay.style.display = "none"; 
			res_bizum.style.display = "none"; 
		}

		// Pay 100% in office: 
		if (reservaD[76] == 1) {
			res_oficina.style.display = "inline-flex"; 
		} else {
			res_oficina.style.display = "none"; 
		}
		
		showSups( sups );
		showYoungDriverWarning();

    // Focus payment form:
   (<HTMLElement>dId("res_step_3_btn")).removeEventListener("click", () =>{} );
   (<HTMLElement>dId("res_step_3_btn")).addEventListener("click", () => { 
    (<HTMLElement>dId("resFormDiv")).scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
    });

    res_confirm.classList.remove("hidden"); 


	} else {

		if (reservaD[51] != "OK") {
			res_button.innerHTML = reservaD[51];
		} else {
			res_button.innerHTML = "<span class='err'>" + langDict[29] + "</span>";
		}

		res_confirm.classList.add("hidden"); 
	}

}






/** Show available supplements for selected vehicle */
function showSups( sups: any[] ) {

    const sup_container = (<HTMLElement>dId("resSuplementos"));
    const sup_div = (<HTMLElement>dId("resSups"));

  if (typeof sups == "undefined" || sups.length == 0) {
    sup_container.classList.add("hidden");
    return;
  }

  logger("Add Sups", "log");

	let sup_sil = "";
	let sup_ins = "";
	let sel = "";

	// Using 10% fixed on the sillas now: 
	// comsillas = parseFloat(reservaD[28])/(parseFloat(reservaD[26])-parseFloat(reservaD[28]));
	// console.log(comsillas);
	
  const sillas = ["CBS","CSI","CSB","CST","BS","CS","BO","BST",];
  const seguro = ["EXT","PRO",];
  
  for (let i=0; i<sups.length; i++) {

    let price = beautifyPrice ( sups[i]["precio"]*(1+comsillas)*(1+IVA) );
    
    let nome = sups[i]["codigo"] + "|" + (parseFloat(sups[i].precio)*(1+comsillas)).toFixed(2) + "|" + sups[i].descripcion;

    if ( sillas.indexOf(sups[i]["codigo"]) >=0 ){

      sel = `<select name='${nome}'  id='suplementos_sillas_${sups[i].codigo}'>
          <option value='0' selected>-</option>
          <option value='1'>1</option>
          <option value='2'>2</option>
          <option value='3'>3</option>
        </select>`;


      sup_sil += `<div class='res_extra_grid_elem'>
                <img src='${URL_BASE}img/sups/${sups[i].codigo}.jpg' 
                  alt=''>
                  <span>${sups[i].descripcion}</span>
                <div>
                  <span>${price} / Ud.</span> 
                  ${sel}
                </div>
            </div>`;
      
    } else if ( seguro.indexOf(sups[i]["codigo"]) >=0 ) {

      // Insurance is fixed price with yes / no option: 
      sel = `<select name='${nome}' id='suplementos_seguros'>
            <option value='0' selected>No</option>
            <option value='1'>Si</option>
          </select>`;

      
      sup_ins += `<table style="width:310px">
              <tr>
                <td style='padding:10px'><label>${sups[i]["descripcion"]}</td>
                <td style='padding:10px'>${price}</label></td>
                <td style='padding:10px'>${sel}</td>
              </tr>
            </table>`; 

    }
  }
	

	if (sup_sil !="" || sup_ins !="" ) {

		let html = `<header>${langDict[36]}</header>
						<div class='res_extra_grid'>
							${sup_sil}
							${sup_ins}
						</div>`;

    sup_div.innerHTML = html;
    sup_container.classList.remove("hidden");


    // Add Event Listener to selects:
    if (sup_sil !="" ) {
      const selects = dQSa("#resSups select");
      selects.forEach( (elem) => {
        const e = elem as HTMLSelectElement;
        e.addEventListener("change", ()=>{ addSuptoStore(); } );
      });
    }
    
	} 

	addSuptoStore();

}

// Store supplements in reservaD.
function addSuptoStore() {

	reservaD[30] = "";
  reservaD[31] = 0;

  // !Not used -  Discounts
	// reservaD[32] = ""; 
	// reservaD[33] = 0;


	// 2021-07
  const selects = dQSa("#resSups select");
  selects.forEach( (elem) => {

    const e = elem as HTMLSelectElement;
    const v = parseInt(e.value);
    const n = e.name.split("|");

    if (v>0) {
      reservaD[30] += n[0] + " x " + v + " - " + n[2] + ": "  + (parseFloat(n[1])*(1+IVA)*v).toFixed(2)  + "€<br>";
      reservaD[31] += parseFloat(n[1])*v;
    }

  });
  
  showPrice();
  drawPresupuestoBox();
	drawPaymentBreakdownBox("no");

  setHform();

}


/**
 * Display price that a young driver will have to pay in the office.
 * Only show if underage selected and price is not zero.
 */
function showYoungDriverWarning() {

	logger("draw Young Driver","log");
	
	const target = <HTMLElement>dId("resYoungWarn");
	const msgdiv = <HTMLElement>dQS("#resYoungWarn label span");
  const checkbox = <HTMLInputElement>dId("f_edad");

	let msg = ""; 

  // Reset to hidden/empty if rendered on screen: 
  if (target == null) {
    return;
  }

  target.style.display = "none";
  msgdiv.innerText = "";
  checkbox.checked = true;

  if (reservaD[34] == 0 || reservaD[34] == "" || reservaD[14]=="Si") {
    return;
  }

	// is value zero (not updated)
	if (reservaD[34] > 0 && reservaD[35] > 0) {
		
		if (reservaD[34]>=999) {	// Not allowed to book

			msg = langDict[60];

		} else if (reservaD[34] <= 0.01) {	// Is allowed but cost is zero

			msg  = langDict[61];

		} else {

			msg = langDict[62].split("{cargo_dia}").join(reservaD[34]);
			msg = msg.split("{cargo_max}").join(reservaD[35]);
			
		}

	} else {
		msg = langDict[63];
	}

	target.style.display = "block";
	msgdiv.innerHTML = msg + "<br><strong>" + langDict[75] + "</strong>";
  checkbox.checked = false;
  
}






/** Car details PopUP 
 * TODO: Add an extra layer for scrolling - perhaps redimension
*/
function showExtraVD(popuptext:string) {
	showPopUp("<div class='innerpop-info'>" + popuptext + "</div>");
}

/** Use the same popup window for everything? ;-/ */
function zoomImg(img:string) {
	showPopUp( "<p style='text-align:center'><img src='" + img + "'></p>");
}





export { showDetail, toggleReservaButtons, showYoungDriverWarning }